import { render, staticRenderFns } from "./OffPath.vue?vue&type=template&id=229be924&scoped=true&"
import script from "./OffPath.vue?vue&type=script&lang=js&"
export * from "./OffPath.vue?vue&type=script&lang=js&"
import style0 from "./OffPath.vue?vue&type=style&index=0&id=229be924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229be924",
  null
  
)

export default component.exports